import { ICorporationResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const infiniteCorporationsDataSourceKey = 'get-infinite-corporations';

const defaultCorporationSort: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];

export type CorporationFilter = Readonly<{
    nameSearch?: string;
}>;

export type CorporationDataSourceOptions = BaseDataSourceOptions<
    ICorporationResponse,
    CorporationFilter
>;

const queryFn: DataSourceQuery<ICorporationResponse, CorporationFilter> = ({
    page,
    pageLimit,
    filter: { nameSearch },
    sort,
}) =>
    toDataSourceResult(
        sdClient.getCorporations({
            filter: Filter.eq('Active', true),
            page,
            pageLimit,
            orderBy: buildOrderBy(sort),
            nameSearch,
        }),
    );

export type CorporationInfiniteDataSource = InfiniteDataSource<
    ICorporationResponse,
    CorporationFilter
>;

export function useInfiniteCorporationDataSource({
    defaultSort = defaultCorporationSort,
    ...options
}: CorporationDataSourceOptions): CorporationInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: queryFn,
    });
}
